
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 40 40"}},[_c('path',{attrs:{"d":"M35 25H21.667v-5h11.667v-3.333H21.667V3.333h-3.333v13.333H6.667v3.333h11.667v5H5v3.333h13.333v8.334h3.333v-8.333h13.333z"}}),_c('path',{attrs:{"d":"M8.408 9.127l2.357-2.357 6.246 6.247-2.356 2.357zm14.58 3.889l6.247-6.247 2.356 2.357-6.246 6.247z"}})]);
        };
      

        module.exports = {
          
          render: render,
        };
      